import React from 'react';
import { ArrowSolidIcon } from '@pushpay/iconography';
import { multiply, clsx, divide, createUseStyles } from '@pushpay/styles';
import { memo } from '@pushpay/types';
const useStyles = createUseStyles(theme => ({
  root: {
    position: 'relative',
    outline: 'none',
    padding: `${multiply(theme.SPACING.GUTTER, 2)} 0`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    '&:hover $hoverArrow': {
      visibility: 'visible'
    }
  },
  arrow: {
    fontSize: theme.SPACING.SMALL_ICON_SIZE,
    minWidth: theme.SPACING.SMALL_ICON_SIZE,
    transition: 'transform 150ms',
    margin: divide(theme.SPACING.GUTTER, 4)
  },
  hoverArrow: {
    visibility: 'hidden'
  },
  hide: {
    visibility: 'hidden'
  }
}));

const AccordionTitle = function AccordionTitle({
  renderTitle,
  item,
  onClick,
  isOpen,
  showArrowOnlyOnHover,
  isExpandable,
  classes: classesProp,
  className: classNameProp,
  'data-pp-at-target': targetId,
  ...rest
}) {
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onClick(item);
    }
  };

  const props = {
    className,
    role: 'button',
    tabIndex: 0,
    onKeyDown: handleKeyDown,
    onClick: () => onClick(item),
    'data-pp-at-target': targetId,
    ...rest
  };

  if (!isExpandable) {
    props.role = 'general';
  }

  return /*#__PURE__*/React.createElement("div", props, renderTitle(item), /*#__PURE__*/React.createElement(ArrowSolidIcon, {
    "data-pp-at-target": `${targetId}-icon`,
    mode: isOpen ? 'up' : 'down',
    className: clsx(classes.arrow, showArrowOnlyOnHover && isExpandable && !isOpen && classes.hoverArrow, !isExpandable && classes.hide)
  }));
};

export default memo(AccordionTitle);